import axios from "axios";
import { apiBaseUrl } from "@/environment";
import { AuthService } from "@/modules/auth";

/**
 * Axios basic configuration
 */
const config = {
  baseURL: apiBaseUrl,
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need
 * to consume APIs from more than single server,
 */
const client = axios.create(config);

/**
 * Auth interceptors
 * @description Add auth tokens to every outgoing requests.
 * @param {*} config
 */

const authInterceptor = (config) => {
  if (AuthService.check()) {
    config.headers.Authorization = `Bearer ${AuthService.token}`;
  }

  return config;
};

/**
 * Logger interceptors
 * @description Log app requests.
 * @param {*} config
 */
const loggerInterceptor = (config) =>
  /** Add logging here */
  config;

/** Adding the request interceptors */
client.interceptors.request.use(authInterceptor);
client.interceptors.request.use(loggerInterceptor);

/** Adding the response interceptors */
// client.interceptors.response.use(
//   (response) => Promise.resolve(response),
//   (error) => {
//     const status = error.response?.status;
//     const requestUrl = error.config?.url;

//     const isTokenEndpoint = requestUrl?.includes('api/token/');

//     // Skip logout only for 401 from api/token/
//     if (
//       (status === 403 || status === 503) ||
//       (status === 401 && !isTokenEndpoint)
//     ) {
//       AuthService.logout();
//     }

//     console.log(error);
//     return Promise.reject(error);
//   }
// );

client.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    console.error("Response error:", error);
    
    const requestUrl = error.config?.url;
    const isTokenEndpoint = requestUrl?.includes('api/token/');
    
    // If we have a response, check its status
    if (error.response) {
      const status = error.response.status;
      if (
        (status === 403 || status === 503) ||
        (status === 401 && !isTokenEndpoint)
      ) {
        AuthService.logout();
      }
    } 
    // If no response (network/CORS error) and it's not the token endpoint
    else if (!isTokenEndpoint) {
      AuthService.logout();
    }
    
    return Promise.reject(error);
  }
);


export default client;
